window.openMap = () => {
  let protocol = 'https'
  if (
    /iPhone|iPod|iPad/.test(navigator.userAgent)
  ) {
    protocol = 'maps'
  }

  window.open(`${protocol}://google.com/maps/?q=-36.8462741,174.7651658`)
}
